import { LogOut01, Moon01, Sun } from "@untitledui/icons";
import { cx, useTheme } from "@tricura/atlas-ui";

interface AccountMenuProps {
    onSignOut?: () => void;
}

export function AccountMenu({ onSignOut }: AccountMenuProps) {
    const { theme, setTheme } = useTheme();
    const isDark =
        theme === "dark" ||
        (theme === "system" && typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches);

    return (
        <div className="border-secondary bg-primary w-[187px] rounded-xl border p-2 shadow-lg">
            {/* Light / Dark segmented toggle */}
            <div className="border-secondary flex rounded-lg border p-1">
                <ToggleButton active={!isDark} onClick={() => setTheme("light")} icon={Sun} label="Light" />
                <ToggleButton active={isDark} onClick={() => setTheme("dark")} icon={Moon01} label="Dark" />
            </div>

            {/* Sign out */}
            <button
                type="button"
                onClick={onSignOut}
                className="text-secondary hover:bg-secondary_hover mt-1 flex w-full items-center gap-2 rounded-md px-2 py-2 text-sm font-semibold transition duration-100 ease-linear"
            >
                <LogOut01 className="text-fg-quaternary size-5" />
                Sign out
            </button>
        </div>
    );
}

interface ToggleButtonProps {
    active: boolean;
    icon: React.ComponentType<{ className?: string }>;
    label: string;
    onClick: () => void;
}

function ToggleButton({ active, icon: Icon, label, onClick }: ToggleButtonProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={cx(
                "flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-sm font-semibold transition duration-100 ease-linear",
                active ? "bg-primary text-primary ring-primary shadow-xs ring-1" : "text-tertiary hover:text-secondary",
            )}
        >
            <Icon className="size-4" />
            {label}
        </button>
    );
}
